import { useQuery } from '@tanstack/react-query';
import { authAPI } from '../services/api';

export const useProfile = () => {
  // Get user profile
  const {
    data: profile,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['profile'],
    queryFn: authAPI.getProfile,
  });

  return {
    profile,
    employee: profile?.employee,
    isLoading,
    error,
    refetch,
  };
};

